export default {
    styleCanBeApplied: true,
    heightAuto: true
}
